import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"

export const Pagination = ({ isFirst, isLast, prevPage, nextPage }) => {
  return (
    <PaginationWrapper>
      {isFirst ? (
        <Disabled>Föregående sida</Disabled>
      ) : (
        <PaginationElement to={prevPage}>Föregående sida</PaginationElement>
      )}
      {isLast || !nextPage ? (
        <Disabled>Nästa sida</Disabled>
      ) : (
        <PaginationElement to={nextPage}>Nästa sida</PaginationElement>
      )}
    </PaginationWrapper>
  )
}

const PaginationWrapper = styled.nav`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2.5rem;
  padding: 3rem 0 1rem;
  font-size: 0.875rem;
`

const PaginationElement = styled(Link)`
  color: var(--fg);
  text-decoration: none;

  &:hover,
  &:focus {
    text-decoration: underline;
    text-underline-offset: 0.2em;
  }
`

const Disabled = styled.span`
  color: var(--muted);
  opacity: 0.7;
`
